import { Injectable } from '@angular/core';
import { AccessRoles } from '../../entity/constants';

@Injectable({
  providedIn: 'root'
})
export class AuthorizedRolesService {

    
  IsAuthorized(roles: Array<string>): boolean {
    return this.IsManager(roles) || this.isAdmin(roles) || this.IsIntelligence(roles) || this.isSuperUser(roles);
  }

  IsManager(roles: Array<string>): boolean {
    return roles.includes(AccessRoles.MANAGER);
  }

  isSuperUser(roles: Array<string>): boolean {
    return roles.includes(AccessRoles.SUPERUSER);
  }

  IsIntelligence(roles: Array<string>): boolean {
    return roles.includes(AccessRoles.INTELLIGENCE) || roles.includes(AccessRoles.GLOBALINTELLIGENCE);
  }

  isAdmin(roles: Array<string>): boolean {
    return roles.includes(AccessRoles.ADMINISTRATOR) || roles.includes(AccessRoles.GLOBALADMINISTRATOR);
  }

}